/**
 * @module M/control/ScaleZoomControl
 */

import ScaleZoomImplControl from 'impl/scalezoomcontrol';
import template from 'templates/scalezoom';
import { getValue } from './i18n/language';

export default class ScaleZoomControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(plugin) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(ScaleZoomImplControl)) {
      M.exception('La implementación usada no puede crear controles ScaleZoomControl');
    }
    // 2. implementation of this control
    const impl = new ScaleZoomImplControl();
    super(impl, 'ScaleZoom');
    this.plugin_ = plugin;
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    return new Promise((success, fail) => {
      const html = M.template.compileSync(template, {
        vars: {
          translations: {
            tooltip1: getValue('tooltip1'),
            tooltip2: getValue('tooltip2'),
          },
        },
      });
      // Añadir código dependiente del DOM
      const button1 = html.querySelector('#button1');
      const button2 = html.querySelector('#button2');
      button1.addEventListener('click', () => {
        const scales = {
          '1:25.000': 15,
          '1:20.000': 15,
          '1:30.000': 15,
          '1:40.000': 14,
          '1:50.000': 14,
          '1:60.000': 14,
          '1:10.000': 15,
          '1:5.000': 16,
          '1:2.500': 16,
        };
        this.state_.zoom = scales[this.state_.scale];
        this.callbackState_(this.state_);
        this.plugin_.setMapCenterZoom(this.state_.mapa, this.state_.zoom);
      });
      button2.addEventListener('click', () => {
        const scales = {
          '1:25.000': 11,
          '1:20.000': 12,
          '1:30.000': 11,
          '1:40.000': 10,
          '1:50.000': 10,
          '1:60.000': 10,
          '1:10.000': 13,
          '1:5.000': 14,
          '1:2.500': 15,
        };
        this.state_.zoom = scales[this.state_.scale];
        this.callbackState_(this.state_);
        this.plugin_.setMapCenterZoom(this.state_.mapa, this.state_.zoom);
      });
      success(html);
    });
  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {}
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {}
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-scalezoom button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof ScaleZoomControl;
  }

  setState(state) {
    this.state_ = state;
  }

  setCallbackState(callback) {
    this.callbackState_ = callback;
  }
}
